import { AHIcon, AHText, Box } from "arkh";
import { FormattedMessage } from "react-intl";

export function TopicAndDisableableIndicator(props: {
  orgCanBeDisabled: boolean;
  orgTopic: {
    name: string;
  } | null;
}) {
  return (
    <Box
      spaceRight="medium"
      style={{ flexDirection: "row", alignItems: "center" }}
    >
      {props.orgCanBeDisabled ? (
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          <AHText type="list-item-title-secondary" spaceRight="xsmall">
            <FormattedMessage
              defaultMessage="Can be hidden locally"
              description="RoutineEditChecklistSectionHeader allow units to disable"
            />
          </AHText>
        </Box>
      ) : null}
      {props.orgTopic ? (
        <Box
          spaceLeft="medium"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <AHText type="list-item-title-secondary" spaceRight="xsmall">
            {props.orgTopic?.name}
          </AHText>
          <AHIcon type="topic" color="text-secondary" />
        </Box>
      ) : null}
    </Box>
  );
}
